import moment from 'moment';

let dt_index = null;
let microsite_id = null;
let calendar_id = null;
let content_type = null;
let dt_calendar_entries = null;


export function index(params){

    dt_index = $('#calendars_table').DataTable({
        ajax: {
            url: $('#calendars_table').attr('url'),
        },
        select: {
            style: 'multi+shift',
        },  
        columns: [
            { width: '20', data: 'id', orderable: false, searchable: false, checkboxes: { selectRow: true } },
            { width: '20', data: null, orderable: false, searchable: false, class: 'actions', render: render_calendars_actions },
            { data: 'name', orderable: true, searchable: true },
        ],
        order: [[2, 'asc']],
    });

    dt_index.on('init', function(e, settings, json){
        $(settings.nTableWrapper).find('.table_batch_actions [action="delete_calendars"]').click(batch_delete_calendars);
    });

    microsite_id = params.microsite_id;
}

function render_calendars_actions(data, type, row){

    const url_info = ($("#calendars_table").attr('url_info') ?? '').replace('#', row.id);

    const actions = 
        '<div class="btn-group" role="group">' +
        '   <a class="btn btn-primary btn-xs show ajax" href="' + url_info + '">' + window.__('info') + '</a>' +
        '</div>';

    return actions;

}

export function show(params){

    // datatable calendar_entries
    
    dt_calendar_entries = $('#calendar_entries_table').DataTable({
        ajax: {
            url: $('#calendar_entries_table').attr('url'),
        },
        select: {
            style: 'multi+shift',
        },
        autoWidth: false,
        columns: [
            { width: '20', data: 'content_id', orderable: false, searchable: false, checkboxes: { selectRow: true } },
            { width: '20', data: null, orderable: false, searchable: false, class: 'actions', render: render_calendar_entries_actions },
            { width: '20', data: 'visibility', class: 'px-0', orderable: false, searchable: false , render: render_calendar_entries_visible},
            { data: 'date_start', orderable: true, searchable: true, render: datatables.render_date},
            { data: 'title', orderable: true, searchable: true},
            { data: 'status', orderable: true, searchable: true},
        ],
        order: [3,'asc'],
    });

    dt_calendar_entries.on('init', function(e, settings, json){
        $(settings.nTableWrapper).find('.table_batch_actions [action="delete_calendar_entries"]').click(batch_delete_calendar_entries);
        $(settings.nTableWrapper).find('.table_batch_actions [action="delete_content"]').click(batch_delete_contents);
    });

    microsite_id = params.microsite_id;
    calendar_id = params.calendar_id;
    content_type = params.content_type;

    $('#modal_create_calendar_entries').on('show.bs.modal', function (event) {
        let today = moment().format('yyyy-MM-DD hh:mm');
        $(this).find('[name="published_at"]').val(today);
        $(this).find('[name="date_start"]').val(today);
    })

    $('#add_calendar_entry').on('submit', function(e) {
        e.preventDefault();

        let modal = $(this).closest('.modal');
        let url = $(this).attr('action');
        let form_data = new FormData();

        form_data.append('selected', false);
        form_data.append('calendar_id', $(this).find('[name="calendar_id"]').val());
        form_data.append('content_id', $(this).find('[name="content_id"]').val());

        window.forms.post(url, form_data, true, true)
        .then((response) => {
            if (response.data != null) {
                switch (response.data.message_level) {
                    case 'error':
                        window.messages.error(response.data.message);
                        break;
                
                    default:
                        window.messages.info(response.data.message);
                        break;
                }
            }
        })
        .catch((error) => {
            console.log('ERROR', error);
        })
        .finally(() => {
            window.blockui.release();
            modal.modal('hide');
            calendar_entries_reload();
        });
    });

    $('#new_content').on('submit', function(e) {
        e.preventDefault();
        let form = $(this);
        let url = $(this)[0].action;
        let form_data = new FormData($(this)[0]);

        window.forms.post(url, form_data, true, true)
        .then((response) => {
            if (response.data != null) {
                switch (response.data.message_level) {
                    case 'error':
                        window.messages.error(response.data.message);
                        break;
                
                    default:
                        window.messages.info(response.data.message);
                        break;
                }
            }
        })
        .catch((error) => {
            console.log('ERROR', error);
        })
        .finally(() => {
            window.blockui.release();
            form[0].reset();
            form.closest('.modal').modal('hide');
            calendar_entries_reload();
        });
    });
}

function render_calendar_entries_actions(data, type, row){
    const url_info = ($("#calendar_entries_table").attr('url_info') ?? '').replace('#', row.content_id).replace('~', content_type);

    const actions = 
        '<div class="btn-group" role="group">' +
        '   <a class="btn btn-primary btn-xs show ajax" href="' + url_info + '">' + window.__('info') + '</a>' +
        '</div>';

    return actions;
}

function render_calendar_entries_visible(data, type, row){

    let visibility = '<div class="btn-group" role="group">';
    
    switch (row.visible) {

        case 'hidden':
            visibility +='   <button class="btn btn-default btn-xs btn-visibility visibility disabled" title="' + window.__(row.visibility) + '"><i class="fa-solid fa-eye-slash"></i></button>';
            break;

        case 'visible':    
            visibility +='   <button class="btn btn-primary btn-xs btn-visibility visibility disabled" title="' + window.__(row.visibility) + '"><i class="fa-solid fa-eye"></i></button>';
            break;

        case 'only_guest':
            visibility +='   <button class="btn btn-secondary btn-xs btn-visibility visibility disabled" title="' + window.__(row.visibility) + '"><i class="fa-solid fa-user-secret"></i></button>';
            break;

        case 'only_users':
            visibility +='   <button class="btn btn-info btn-xs btn-visibility visibility disabled" title="' + window.__(row.visibility) + '"><i class="fa-solid fa-user"></i></button>';
            break;

        case 'only_health':
            visibility +='   <button class="btn btn-success btn-xs btn-visibility visibility disabled" title="' + window.__(row.visibility) + '"><i class="fa-solid fa-user-doctor"></i></button>';
            break;
            
    }
            
    visibility += '</div>';

    return visibility;
}

export function filter_calendar_entries(data) {

    let results = $.map(data.results, function(obj, index) {
        return { 
            id: obj.id, 
            text: obj.title,
            result: obj.title + '<small class="d-block font-weight-light">' + obj.slug + "</small>"
        };
    });

    return {
        results: results
    };
}

export function index_reload(){
    
    dt_index.ajax.reload();

}

export function index_force_reload(){

    dt_index.column(0).checkboxes.deselectAll();
    dt_index.ajax.reload();

}

export function calendar_entries_reload(){

    dt_calendar_entries.ajax.reload();

}

function batch_delete_calendars(){

    const table = $(this).closest('.dataTables_wrapper').find('.dataTable').DataTable();
    const rows_selected = table.column(0).checkboxes.selected();
    const route = window._routes['microsites.calendars.batch_delete'].replace('{microsite}', microsite_id);
    
    let calendars_id = [];
    $.each(rows_selected, function(index, rowId){
        calendars_id.push(rowId);
    });
    
    if(calendars_id.length == 0){

        window.messages.error(__('No has seleccionado ningún calendario'));

    } else {

        const title = __('Eliminar calendarios');
        const text = 
            trans_choice('{1} Estás a punto de eliminar un calendario.|[2,*] Estás a punto de eliminar :count calendarios.', calendars_id.length)
            + ' ' + __('Esta acción no se puede deshacer ¿quieres continuar?');
        
        window.messages
            .confirm(title, text)
            .then(
                _ => {

                    let calendarData = new FormData();
                    calendarData.append('microsite_id', microsite_id);
                    for(let calendar_id of calendars_id){
                        calendarData.append('calendars_id[]', calendar_id);
                    }

                    window.forms.post(route, calendarData);

                }, 
                _ => {}
            );
    }
}
function batch_delete_calendar_entries(){

    const table = $(this).closest('.dataTables_wrapper').find('.dataTable').DataTable();
    const rows_selected = table.column(0).checkboxes.selected();
    const route = window._routes['microsites.calendars.batch_delete_calendar_entries'].replace('{microsite}', microsite_id).replace('{calendar}', calendar_id);
    
    let entries_id = [];
    $.each(rows_selected, function(index, rowId){
        entries_id.push(rowId);
    });
    
    if(entries_id.length == 0){

        window.messages.error(__('No has seleccionado ninguna entrada'));

    } else {

        const title = __('Eliminar entradas');
        const text = 
            trans_choice('{1} Estás a punto de eliminar una entrada.|[2,*] Estás a punto de eliminar :count entradas.', entries_id.length);
        
        window.messages
            .confirm(title, text)
            .then(
                _ => {

                    let calendarData = new FormData();
                    calendarData.append('microsite_id', microsite_id);
                    calendarData.append('calendar_id', calendar_id);
                    for(let calendar_id of entries_id){
                        calendarData.append('entries_id[]', calendar_id);
                    }

                    window.forms.post(route, calendarData);

                }, 
                _ => {}
            );
    }
}

function batch_delete_contents(){

    const table = $(this).closest('.dataTables_wrapper').find('.dataTable').DataTable();
    const rows_selected = table.column(0).checkboxes.selected();
    const route = window._routes['microsites.contents.batch_delete'].replace('{microsite}', microsite_id);
    
    let contents_id = [];
    $.each(rows_selected, function(index, rowId){
        contents_id.push(rowId);
    });
    
    if(contents_id.length == 0){

        window.messages.error(__('No has seleccionado ningún contenido'));

    } else {

        const title = __('Eliminar contenidos');
        const text = 
            trans_choice('{1} Estás a punto de eliminar un contenido.|[2,*] Estás a punto de eliminar :count contenidos.', contents_id.length)
            + ' ' + __('Esta acción no se puede deshacer ¿quieres continuar?');
        
        window.messages
            .confirm(title, text)
            .then(
                _ => {

                    let formData = new FormData();
                    formData.append('microsite_id', window.microsite_id);
                    for(let content_id of contents_id){
                        formData.append('contents_id[]', content_id);
                    }

                    window.forms.post(route, formData, true, true).then((response) => {

                        if (response.data != null) {
                            switch (response.data.message_level) {
                                case 'error':
                                    window.messages.error(response.data.message);
                                    break;
                            
                                default:
                                    window.messages.info(response.data.message);
                                    break;
                            }
                        }
                    })
                    .catch((error) => {
                        console.log('ERROR', error);
                    })
                    .finally(() => {
                        window.blockui.release();
                        calendar_entries_reload();
                    });
                }, 
                _ => {}
            );
    }
}